<template>
  <div id="pd_home">
    <p class="operation"><router-link to="/">{{$t('Home')}}</router-link> >> {{$t('Project')}}</p>
    <p class="caption headline">{{$t('Project')}}</p>
    <!--<p class="caption">方案展示</p>-->
    <div class="product-display">
      <router-link  v-for="(obj,index) in $t('productDisplay')" :to="obj.href" :key="index">
        <div >
          <img :src="obj.img"/>
          <p>{{obj.name}}</p>
          <p>&nbsp; &nbsp; &nbsp; &nbsp;{{obj.introduce}}</p>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
  export default {
    name: "pd_home",
    data() {
      return {
      }
    }
  }
</script>

<style scoped>
  #paging{
    margin: auto;
    width: 50%;
    border: 1px solid #f8f8f8;
  }
  .introduce {
    width: 400px;
    text-align: center;
    margin: 10px auto;
    font-size: 0.1rem;
  }

  /*产品展示开始*/
  .main-Product{
    background-image: url(../assets/img/pic/pic_PRODUCT.jpg);
    /*background-repeat:no-repeat;*/
  }
  .product-display{
    margin: .3rem .7rem ;
    display: flex;
  }
  .product-display a{
    width: 100%;
    text-align: center;
    flex-grow: 1;
    margin: .1rem;
    transition: all 0.5s;
    background-color: #fff;
    /*padding-bottom: 0.8rem;*/
    /*height: 4rem;*/
    padding-bottom:0.2rem ;
  }
  .product-display a:hover{
    cursor: pointer;
    transform: translate(0,-5px);
    box-shadow: 0 0 30px 0 #B0B0B0;
  }
  .product-display div img{
    width: 100%;
    height: 2rem;
  }
  /*产品展示结束*/
  @media screen and (max-width: 1024px) {
  }

  @media screen and (max-width: 768px) {
    #paging{
      width: 100%;
    }
    .introduce {
      width: 12rem;
      font-size: 0.4rem;
    }
    /* 产品展示 */
    .product-display{
      flex-wrap:wrap;
    }
    .product-display a{
      width: 7rem;
    }
    .product-display div:hover{
      cursor: pointer;
      transform: translate(0,0);
      box-shadow: 0 0 0 0 #B0B0B0;
    }
    .product-display div img{
      height: 4rem;
    }
    .product-display div p:nth-child(2){
      font-size: 16px;
    }
    .product-display div p:nth-child(3){
      font-size: 14px;
      display: -webkit-box;
      /*-webkit-line-clamp: 4;*/
      /*-webkit-box-orient: vertical;*/
      overflow: hidden;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pd_home.vue